import React, { useState, useEffect } from 'react';
import { api, setViewCompany } from './utils/api';
import LoginPage from './pages/LoginPage';
import MainLayout from './pages/MainLayout';

export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('kpi_token');
    if (token) {
      api.me()
        .then(u => setUser(u))
        .catch(() => localStorage.removeItem('kpi_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  // 認証切れ（api.js が発火）を受けてログイン画面へ戻し、理由を伝える。
  useEffect(() => {
    const onUnauthorized = () => {
      setViewCompany(null);
      setUser(null);
      setSessionExpired(true);
    };
    window.addEventListener('kpi-unauthorized', onUnauthorized);
    return () => window.removeEventListener('kpi-unauthorized', onUnauthorized);
  }, []);

  const handleLogin = (token, userData) => {
    localStorage.setItem('kpi_token', token);
    setSessionExpired(false);
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('kpi_token');
    setViewCompany(null);
    setUser(null);
  };

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <div style={{ textAlign: 'center', color: 'var(--ink-mute)' }}>
        <div style={{ fontSize: 32, marginBottom: 12 }}>⚡</div>
        <div>読み込み中...</div>
      </div>
    </div>
  );

  if (!user) return <LoginPage onLogin={handleLogin} notice={sessionExpired ? 'ログインの有効期限が切れました。もう一度ログインしてください。' : ''} />;
  return <MainLayout user={user} onLogout={handleLogout} />;
}
